import { SET_STUDENTS } from "../actions/type";

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STUDENTS:
      return action.payload;

    default:
      return state;
  }
};
